import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';

export function settingsWrapperComponent(WrappedComponent) {
  function SettingsWrapper({
    wrapperClassName = null,
    captionText,
    editButtonText = 'edit',
    isEditable = true,
    ...restProps
  }) {
    const [isEditMode, toggleMode] = useToggle(false);

    return (
      <div className={classnames('p-1 rounded pos-r section', wrapperClassName, { edit: isEditMode })}>
        <fieldset>
          <legend className="fw-bold text-gray-darker mb-1_25 pe-2">{captionText}</legend>
          {isEditable && (
            <Button
              color="link"
              className={classnames('pos-a right-0 top-0 text-transform-none py-0_75 px-1 edit-btn', {
                'mt-0_75 text-primary-darker': !isEditMode,
              })}
              onClick={toggleMode}
            >
              {isEditMode ? <i className="icon-cross2" aria-hidden /> : editButtonText}
            </Button>
          )}
          <WrappedComponent {...restProps} isEditMode={isEditMode} toggleMode={toggleMode} />
        </fieldset>
      </div>
    );
  }

  SettingsWrapper.displayName = `SettingsWrapper(${WrappedComponent.name})`;
  SettingsWrapper.propTypes = {
    captionText: PropTypes.string.isRequired,
    editButtonText: PropTypes.string,
    wrapperClassName: PropTypes.string,
    isEditable: PropTypes.bool,
  };

  return SettingsWrapper;
}
